module.exports = __webpack_public_path__ + "img/95.4.NH3-N.4273d94e.png";